/* eslint-disable no-unused-vars */
import Journey from './abstract-journey.model'
import RoundJourney from './round-journey.model'
import StandardJourney from './standard-journey.model'
import ShuttleJourney from './shuttle-journey.model'

import cloneDeep from 'lodash.clonedeep'

export class SurveyManager {
  constructor(survey) {
    this.survey = survey
  }

  mergeStandardJourney(journeys) {
    return journeys
  }

  static getDaysArray = function (start, end) {
    for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt))
    }
    return arr
  }

  calculateTotalDistances(journeys) {
    const mapper = (journey) => {
      const { type, distance, is_empty } = journey

      if (type === 1) {
        if (is_empty) return { loaded: 0, empty: distance }
        else return { loaded: distance, empty: 0 }
      }
      if (type === 2) {
        return {
          loaded: distance.loaded * journey.num_journeys,
          empty: distance.empty,
        }
      }
      if (type === 3) {
        return {
          loaded: distance.loaded * journey.num_journeys,
          empty: distance.empty * journey.num_journeys,
        }
      }
    }

    const reducer = (acc, { loaded, empty }) => ({
      loaded: acc.loaded + loaded,
      empty: acc.empty + empty,
    })
    return journeys.map(mapper).reduce(reducer, { loaded: 0, empty: 0 })
  }

  // getTotalDistances() {
  //   return this.calculateTotalDistances(this.survey.journeys)
  // }

  getRestructuredJourneys() {
    const { start, end } = this.survey

    const days = SurveyManager.getDaysArray(new Date(start), new Date(end)).map(
      (d) => `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`
    )

    let newJourneys = []
    let journeys = this.mergeStandardJourney(this.survey.journeys)

    let via = 1
    let subVia = 1

    journeys.forEach((j) => {
      let journey = cloneDeep(j)
      journey.date = days[journey.day]

      if (journey.type === Journey.STANDARD) {
        let { is_ended } = journey
        const has_parent = Boolean(journey.parent_id)

        if (has_parent) {
          journey.via = `${via}.${subVia}`
          journey.num_via = via
          journey.num_via_prg = subVia
          subVia++
        } else {
          if (is_ended) {
            journey.via = via
            journey.num_via = via
            journey.num_via_prg = subVia
          } else {
            journey.via = `${via}.${subVia}`
            journey.num_via = via
            journey.num_via_prg = subVia
            subVia++
          }
        }

        if (is_ended) {
          via++
          subVia = 1
        }

        newJourneys.push(StandardJourney.restructured(journey))
      } else if (journey.type === Journey.ROUND) {
        RoundJourney.restructured(journey).forEach((j) => {
          j.via = via
          newJourneys.push(j)
          via++
        })
      } else if (journey.type === Journey.SHUTTLE) {
        ShuttleJourney.restructured(journey).forEach((j) => {
          j.via = via
          newJourneys.push(j)
          via++
        })
      } else {
        // throw `Journey type ${journey.type} not found`
      }
    })

    return newJourneys
  }
}
